//@flow

import * as React from 'react';
import DropzoneArea from 'react-dropzone';
import styled from 'styled-components';
import { translate } from "react-i18next";
import { connect } from 'react-redux';

const DropzoneWrapper = styled.div`
  width: inherit;
  height: inherit;
`;

const StyledDropzoneLabel = styled.div`
  width: 100%;
  height: 100%;
  white-space: normal;
  text-align: center;
  align-items: center;
`;

const StyledImg = styled.img`
  max-width: 196px;
  max-height: 200px;
`;

export class LogoDropZone extends React.Component {

  onDropImage(imageFile, onFileLoad) {
    onFileLoad(imageFile);
  }

  render(): React.Node {
    const {
      onFileLoad,
      logo,
      disabled,
      t,
      defaultLogo
    } = this.props;

    return (
      <DropzoneWrapper>
        <DropzoneArea
          style={{
            width: 'inherit',
            height: 'inherit',
            minHeight: '46px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#265a9c',
            cursor: 'pointer',
          }}
          activeStyle={{ border: '2px solid #265a9c' }}
          acceptStyle={{ border: '2px solid green' }}
          rejectStyle={{ border: '2px solid red' }}
          accept='image/*'
          maxSize={1024000}
          disabled={disabled}
          onDrop={(file) => {
            this.onDropImage(file, onFileLoad)
          }}
          onDropRejected = {() => {
            return window.alert(t('Maximum file upload size is') + ' 1MB');
          }}
        >
          <StyledDropzoneLabel>
            {logo !== null
              ? <StyledImg
                  src={"data:image/*;base64," + logo}
                  alt={t('Drop logo or click to browse file')}>
                </StyledImg>
              : <StyledImg
                  src={defaultLogo}
                  alt={t('There is no logo for this customer')}>
                </StyledImg>
            }
          </StyledDropzoneLabel>
        </DropzoneArea >
      </DropzoneWrapper>
    );
  }
};

const mapStateToProps = (state: State) => ({
  defaultLogo: state.domainProperties.get('whiteLogo'),  
});

export default translate("translations")(connect(mapStateToProps, null)(LogoDropZone));


// WEBPACK FOOTER //
// ./src/containers/content/logo/LogoDropZone.jsx